import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import AppCard, { AppCardProps } from "../../common/AppCard/AppCard";
import styles from "./ConsoleDemo.module.scss";

interface Props {
	cards: AppCardProps[];
}

const ConsoleDemo = ({ cards }: Props) => {
	return (
		<Box className={styles.wrapper}>
			{cards.map(({ card, onClick }) => (
				<AppCard key={card} card={card} onClick={onClick} className={styles.card} />
			))}
		</Box>
	);
};

export default observer(ConsoleDemo);
